/**
 * The record page's pager (SA-411): one component under whichever table is
 * showing — the register or the legacy table. Props only: it is rendered by
 * `OrdersPage`, which lives in the hand-rolled `useOrders` lane, so no React
 * Query here. Shape follows the CRM contact list's pager.
 */
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui'

interface ListPagerProps {
  page: number
  pageSize: number
  total: number
  onPage: (page: number) => void
}

export function ListPager({ page, pageSize, total, onPage }: ListPagerProps) {
  const totalPages = Math.ceil(total / pageSize)
  if (totalPages <= 1) return null
  return (
    <nav aria-label="Pagination" className="flex items-center justify-between pt-3 text-sm">
      <span className="text-muted-foreground">
        Showing {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total}
      </span>
      <div className="flex items-center gap-2">
        <Button type="button" variant="ghost" size="sm" aria-label="Previous page" className="h-8 w-8 p-0"
          disabled={page <= 1} onClick={() => onPage(page - 1)}>
          <ChevronLeft aria-hidden="true" className="w-4 h-4" />
        </Button>
        <span className="text-foreground min-w-[80px] text-center">Page {page} of {totalPages}</span>
        <Button type="button" variant="ghost" size="sm" aria-label="Next page" className="h-8 w-8 p-0"
          disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
          <ChevronRight aria-hidden="true" className="w-4 h-4" />
        </Button>
      </div>
    </nav>
  )
}
